import { StyleSheet } from 'react-native'

const mobileStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFF',
    width: '100%',
    // Web only: force full viewport height (not just a cap) so the inner
    // ScrollView/FlatList scrolls internally and the Footer stays pinned.
    // On native, flex:1 already handles this — and '100vh' is a web-only
    // unit, so we keep it off native entirely.
    ...(isWeb() ? { height: '100vh' } : {}),
  },
  commentsContainer: {
    width: '100%',
    alignSelf: 'center',
    flex: 1,
    marginTop: 10,
  },
  commentContainer: {
    marginTop: 20,
    maxWidth: '80%',
    flex: 1,
  },
  secondaryCommentContainer: {
    alignSelf: 'flex-end',
  },
  secondaryCommentUserName: {
    fontWeight: 'bold',
    alignSelf: 'flex-end',
  },
  secondaryCommentDateTime: {
    fontWeight: 'bold',
    alignSelf: 'flex-end',
    color: 'rgba(0, 0, 0, .4)',
  },
  secondaryComment: {
    backgroundColor: 'rgba(34, 197, 94, 0.1)',
    borderRightWidth: 3,
    borderRightColor: '#22c55e',
    alignSelf: 'flex-end',
    width: '100%',
    padding: 16,
    borderRadius: 8,
    borderTopRightRadius: 0,
  },
  primaryComment: {
    backgroundColor: 'rgba(255, 196, 81, 0.15)',
    borderLeftWidth: 3,
    borderLeftColor: '#FFC451',
    width: '100%',
    padding: 16,
    borderRadius: 8,
    borderTopLeftRadius: 0,
  },
});
import { isWeb } from '../util/platform';

export default mobileStyles;
